import Api from '../../commons/api';

const VENDOR_RETAIL_API = '/vendor-retail';

export const getVendorRetailBookingsByVendor = async (vendorId) => {
  try {
    // console.log(`📡 [Service] Calling API: ${VENDOR_RETAIL_API}/my-bookings?vendorId=${vendorId}`);
    const response = await Api.get(`${VENDOR_RETAIL_API}/my-bookings?vendorId=${vendorId}`);
    // console.log(`✅ [Service] Received ${response.data?.length || 0} bookings from API`);
    return response.data;
  } catch (error) {
    console.error('❌ [Service] Error fetching vendor retail bookings:', error);
    throw error;
  }
};

export const getVendorUnpaidRetailBookings = async (vendorId) => {
  try {
    console.log(
      `📡 [Service] Calling API: ${VENDOR_RETAIL_API}/unpaid-bookings?vendorId=${vendorId}`,
    );
    const response = await Api.get(`${VENDOR_RETAIL_API}/unpaid-bookings?vendorId=${vendorId}`);
    console.log(`✅ [Service] Received ${response.data?.length || 0} unpaid bookings from API`);
    return response.data;
  } catch (error) {
    console.error('❌ [Service] Error fetching unpaid retail bookings:', error);
    throw error;
  }
};

export const getVendorPaidRetailBookings = async (vendorId) => {
  try {
    console.log(
      `📡 [Service] Calling API: ${VENDOR_RETAIL_API}/paid-bookings?vendorId=${vendorId}`,
    );
    const response = await Api.get(`${VENDOR_RETAIL_API}/paid-bookings?vendorId=${vendorId}`);
    console.log(`✅ [Service] Received ${response.data?.length || 0} paid bookings from API`);
    return response.data;
  } catch (error) {
    console.error('❌ [Service] Error fetching paid retail bookings:', error);
    throw error;
  }
};

export const checkSlotAvailability = async (retailScheduleId, bookingDate, startTime, endTime) => {
  try {
    const params = {
      retailScheduleId,
      bookingDate,
      startTime,
      endTime,
    };
    const response = await Api.get(`${VENDOR_RETAIL_API}/check-availability`, params);
    return response.data;
  } catch (error) {
    console.error('Error checking slot availability:', error);
    throw error;
  }
};

export const createVendorRetailBooking = async (bookingData) => {
  try {
    const response = await Api.post(VENDOR_RETAIL_API, bookingData);
    return response.data;
  } catch (error) {
    console.error('Error creating vendor retail booking:', error);
    throw error;
  }
};

export const updateVendorRetailBooking = async (bookingId, updateData) => {
  try {
    const response = await Api.put(`${VENDOR_RETAIL_API}/${bookingId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating vendor retail booking:', error);
    throw error;
  }
};

export const getBookingById = async (bookingId) => {
  try {
    const response = await Api.get(`${VENDOR_RETAIL_API}/${bookingId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching booking:', error);
    throw error;
  }
};

export const createRetailCheckoutSession = async (sessionData) => {
  try {
    const response = await Api.post(`${VENDOR_RETAIL_API}/create-checkout-session`, sessionData);
    return response.data;
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};

export const cancelRetailBooking = async (bookingId, vendorId, reason) => {
  try {
    const response = await Api.post(`${VENDOR_RETAIL_API}/cancel`, {
      bookingId,
      vendorId,
      reason,
    });
    return response.data;
  } catch (error) {
    console.error('Error cancelling booking:', error);
    throw error;
  }
};

// Venue-side services
export const getVenueRetailApplications = async (venueId) => {
  try {
    const response = await Api.get(`${VENDOR_RETAIL_API}/venue/${venueId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching venue retail applications:', error);
    throw error;
  }
};

export const updateRetailApplicationStatus = async (bookingId, newStatus) => {
  try {
    const response = await Api.put(`${VENDOR_RETAIL_API}/${bookingId}/status`, {
      newStatus,
    });
    return response.data;
  } catch (error) {
    console.error('Error updating retail application status:', error);
    throw error;
  }
};

export const venueCancelRetailBooking = async (bookingId, venueId, reason) => {
  try {
    const response = await Api.post(`${VENDOR_RETAIL_API}/venue-cancel`, {
      bookingId,
      venueId,
      reason,
    });
    return response.data;
  } catch (error) {
    console.error('Error cancelling retail booking (venue):', error);
    throw error;
  }
};
